<template>
  <div>
    <div id="tres-indicadores-pre-natal" class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Os 3 Indicadores Pré-natal"
            description="Situação dos 3 indicadores de pré-natal por gestante que vai parir no quadrimestre atual"
            :enabledModalInformacao="true"
            :textModalInformacao="textModalInformacao"
            url="/pre-natal"
          />
        </div>
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="equipes"
              label="no_equipe"
              placeholder="Equipes"
              @input="onChangeEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_equipe }}
                {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-md-12">
          <b-tabs
            content-class="mt-3"
            fill
            class="esus-feedback-tabs"
            v-model="tabsActive"
          >
            <b-tab title="Lista">
              <template v-slot:title>
                <i class="icofont-list"></i> Lista
              </template>
              <div class="row">
                <div class="col-lg-12">
                  <div class="info-table">
                    <div class="info-table-item">
                      <download-files
                        :callback-pdf="generatePdf"
                        :data="displayedCadastros"
                        :fields="dataFields"
                        name="os-3-indicadores-pre-natal"
                      >
                      </download-files>
                    </div>
                  </div>
                </div>
                <div class="full-table">
                  <div class="col-md-12">
                    <tabela-cadastros-vuetfy
                      ref="table"
                      :cadastros="displayedCadastros"
                      :data_secretaria_de_saude="data_secretaria_de_saude"
                      :loading="loading"
                      texto_esus_pec="Atendimentos ou procedimentos registrados até"
                      :data_esus_pec="data_secretaria_de_saude"
                      @filterSearch="filterSearch($event)"
                    ></tabela-cadastros-vuetfy>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Resumido">
              <template v-slot:title>
                <i class="icofont-mathematical-alt-1"></i> Resultado
              </template>
              <div class="row">
                <div class="col-lg-12">
                  <div class="box">
                    <div class="box-header">
                      <h4 class="box-title">
                        <i class="icofont-listine-dots"></i> Resultado
                      </h4>
                    </div>
                    <div class="box-body">
                      <table
                        class="table table-responsive table-bordered text-center table2"
                        id="table"
                      >
                        <thead>
                          <tr>
                            <th>Por</th>
                            <!-- <th>
                              Estimadas
                              <span
                                v-b-tooltip.hover
                                title="Quantidade de gestantes estimadas pelo Ministério da Saúde (denominador estimado)"
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </th> -->
                            <th>
                              Denominador
                              <span
                                v-b-tooltip.hover
                                :title="denominadorTitle"
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </th>
                            <th>
                              Pré-natal
                              <span
                                v-b-tooltip.hover
                                title="Gestantes com 6 ou mais consultas de pré-natal (PN), sendo a primeira realizada até a 12ª semana de gestação (numerador)"
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </th>
                            <th>
                              Odontologia
                              <span
                                v-b-tooltip.hover
                                title="Gestantes com atendimento odontológico realizado (numerador)"
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </th>
                            <th>
                              HIV e Sífilis
                              <span
                                v-b-tooltip.hover
                                title="Gestantes com realização de exames para sífilis e HIV (numerador)"
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Município</td>
                            <!-- <td class="text-center font-weight-bold">
                              <loader
                                :value="por_municipio_gestantes_estimadas"
                                :loading="loading"
                              ></loader>
                            </td> -->
                            <td class="text-center font-weight-bold">
                              <loader
                                :value="por_municipio_gestantes_informadas"
                                :loading="loading"
                              ></loader>
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              v-bind:class="
                                printColorColumnPreNatal(
                                  por_municipio_pre_natal_resultado
                                )
                              "
                            >
                              <loader
                                :value="
                                  por_municipio_pre_natal +
                                  ' (' +
                                  por_municipio_pre_natal_resultado +
                                  '%)'
                                "
                                :loading="loading"
                              ></loader>
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              v-bind:class="
                                printColorColumn(
                                  por_municipio_odontologia_resultado
                                )
                              "
                            >
                              <loader
                                :value="
                                  por_municipio_odontologia +
                                  ' (' +
                                  por_municipio_odontologia_resultado +
                                  '%)'
                                "
                                :loading="loading"
                              ></loader>
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              v-bind:class="
                                printColorColumn(
                                  por_municipio_hiv_sifilis_resultado
                                )
                              "
                            >
                              <loader
                                :value="
                                  por_municipio_hiv_sifilis +
                                  ' (' +
                                  por_municipio_hiv_sifilis_resultado +
                                  '%)'
                                "
                                :loading="loading"
                              ></loader>
                            </td>
                          </tr>
                          <tr>
                            <td>Equipe</td>
                            <!-- <td class="text-center font-weight-bold">
                              <loader
                                :value="por_equipe_gestantes_estimadas"
                                :loading="loading"
                              ></loader>
                            </td> -->
                            <td class="text-center font-weight-bold">
                              <loader
                                :value="por_equipe_gestantes_informadas"
                                :loading="loading"
                              ></loader>
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              v-bind:class="
                                printColorColumnPreNatal(
                                  por_equipe_pre_natal_resultado
                                )
                              "
                            >
                              <loader
                                :value="
                                  por_equipe_pre_natal +
                                  ' (' +
                                  por_equipe_pre_natal_resultado +
                                  '%)'
                                "
                                :loading="loading"
                              ></loader>
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              v-bind:class="
                                printColorColumn(
                                  por_equipe_odontologia_resultado
                                )
                              "
                            >
                              <loader
                                :value="
                                  por_equipe_odontologia +
                                  ' (' +
                                  por_equipe_odontologia_resultado +
                                  '%)'
                                "
                                :loading="loading"
                              ></loader>
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              v-bind:class="
                                printColorColumn(
                                  por_equipe_hiv_sifilis_resultado
                                )
                              "
                            >
                              <loader
                                :value="
                                  por_equipe_hiv_sifilis +
                                  ' (' +
                                  por_equipe_hiv_sifilis_resultado +
                                  '%)'
                                "
                                :loading="loading"
                              ></loader>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p class="fonte">
                        <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import SectionTitle from '@/components/SectionTitle'
import Subtitle from '@/components/Subtitle'
import utils from '@/mixins/utils.js'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import VueApexCharts from 'vue-apexcharts'
import { chartOptions, infoHtml } from './utils.js'
import * as Functions from './functions.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'TresIndicadoresPreNatalPorEquipe',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    SectionTitle,
    TabelaCadastrosVuetfy,
    apexchart: VueApexCharts,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      populacaoIbge: 0,
      totalCadastrosMunicipio: 0,
      totalCadastrosEquipe: '',
      parametro: '',
      diferencaDeCadastros: '',
      diferenca_no_municipio: '',
      resultado_no_municipio: '',
      diferenca_na_equipe: '',
      resultado_na_equipe: '',
      total_de_registros_da_tabela: 0,
      data_secretaria_de_saude: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      visibleTable: false,
      por_municipio_gestantes_estimadas: '',
      por_municipio_gestantes_informadas: '',
      por_municipio_pre_natal: '',
      por_municipio_odontologia: '',
      por_municipio_hiv_sifilis: '',
      por_municipio_pre_natal_resultado: '',
      por_municipio_odontologia_resultado: '',
      por_municipio_hiv_sifilis_resultado: '',
      por_equipe_gestantes_estimadas: '-',
      por_equipe_gestantes_informadas: '-',
      por_equipe_pre_natal: '-',
      por_equipe_odontologia: '-',
      por_equipe_hiv_sifilis: '-',
      por_equipe_pre_natal_resultado: '',
      por_equipe_odontologia_resultado: '',
      por_equipe_hiv_sifilis_resultado: '',
      nomeEquipe: '',
      arrayChartMunicipioPreNatal: [],
      arrayChartMunicipioOdontologia: [],
      arrayChartMunicipioHivSifilis: [],
      data_dados_chart: '',
      xaxis: [],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      // entidade: 'tb_fat_atendimento_individual_pre_natal',
      entidade: 8,
      text: '',
      tabsActive: 0,
      dadosDoResultadoPreNatal: [],
      dadosDoResultadoOdontologia: [],
      dadosDoResultadoHivSifilis: [],
      cadastros: [],
      cadastrosOriginais: [],
      textModalInformacao: infoHtml,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    // eslint-disable-next-line vue/return-in-computed-property
    denominadorTitle() {
      let text = 'Gestantes a parir no quadrimestre atual. '
      if (parseInt(this.por_municipio_gestantes_estimadas) === 0) {
        text +=
          'Cadastros maior ou igual à 85% do público alvo no indicador, logo a estimativa é desconsiderada.'
      } else {
        text += `A estimativa no indicador é de ${this.por_municipio_gestantes_estimadas} pessoas para o município.`
      }
      return text
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      let data = this.$store.getters['getEquipes']
      data.push({
        nu_ine: 'sem-equipe',
        no_equipe: 'SEM EQUIPE',
      })
      return this.removeDuplicate(data, 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loading = true
        this.equipe = event
        this.tabsActive = 0
        this.nomeEquipe = event.no_equipe
        this.por_equipe_gestantes_estimadas = 0
        this.por_equipe_gestantes_informadas = 0
        this.por_equipe_pre_natal = 0
        this.por_equipe_odontologia = 0
        this.por_equipe_hiv_sifilis = 0
        this.por_equipe_pre_natal_resultado = 0
        this.por_equipe_odontologia_resultado = 0
        this.por_equipe_hiv_sifilis_resultado = 0
        try {
          this.loading = true
          if (this.equipe.nu_ine != 'sem-equipe') {
            const dadosDaEquipePreNatal = this.dadosDoResultadoPreNatal.find(
              (item) => {
                return item.ibge_ine === this.equipe.nu_ine
              }
            )
            this.por_equipe_gestantes_estimadas =
              dadosDaEquipePreNatal.estimativa
            this.por_equipe_gestantes_informadas =
              dadosDaEquipePreNatal.denominador
            this.por_equipe_pre_natal = dadosDaEquipePreNatal.numerador
            this.por_equipe_pre_natal_resultado =
              dadosDaEquipePreNatal.resultado

            const dadosDaEquipeOdontologia =
              this.dadosDoResultadoOdontologia.find((item) => {
                return item.ibge_ine === this.equipe.nu_ine
              })
            this.por_equipe_gestantes_estimadas =
              dadosDaEquipeOdontologia.estimativa
            this.por_equipe_odontologia = dadosDaEquipeOdontologia.numerador
            this.por_equipe_odontologia_resultado =
              dadosDaEquipeOdontologia.resultado

            const dadosDaEquipeHivSifilis =
              this.dadosDoResultadoHivSifilis.find((item) => {
                return item.ibge_ine === this.equipe.nu_ine
              })
            this.por_equipe_gestantes_estimadas =
              dadosDaEquipeHivSifilis.estimativa
            this.por_equipe_hiv_sifilis = dadosDaEquipeHivSifilis.numerador
            this.por_equipe_hiv_sifilis_resultado =
              dadosDaEquipeHivSifilis.resultado

            let response5 = await this.$api.get(
              '/app/tres-indicadores-pre-natal/equipe/detalhado/' +
                this.cod_ibge +
                '/' +
                this.equipe.nu_ine
            )
            if (response5) {
              this.cadastrosOriginais = response5.data
              this.cadastros = response5.data
              this.filtros()
              // this.carregarSerieHistoricaPorEquipe(this.equipe);
            }
          } else {
            let response6 = await this.$api.get(
              '/app/tres-indicadores-pre-natal/sem-equipe/detalhado/' +
                this.cod_ibge
            )
            if (response6) {
              this.cadastrosOriginais = response6.data
              this.cadastros = response6.data
              this.filtros()
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        this.tabsActive = 0
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''
        this.nomeEquipe = ''
        return
      }
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true

        // busca os dados do municipio pre-natal
        let response2 = await this.$api.get(
          '/app/indicadores-aps/resultado/' + this.cod_ibge + '/1'
        )
        if (response2) {
          this.dadosDoResultadoPreNatal = response2.data
          const dadosDoMunicipioPreNatal = this.dadosDoResultadoPreNatal.find(
            (item) => {
              return item.ibge_ine === 'MUN'
            }
          )
          this.por_municipio_gestantes_estimadas =
            dadosDoMunicipioPreNatal.estimativa
          this.por_municipio_gestantes_informadas =
            dadosDoMunicipioPreNatal.denominador
          this.por_municipio_pre_natal = dadosDoMunicipioPreNatal.numerador
          this.por_municipio_pre_natal_resultado =
            dadosDoMunicipioPreNatal.resultado
        }

        // busca os dados do municipio odontologia
        let response3 = await this.$api.get(
          '/app/indicadores-aps/resultado/' + this.cod_ibge + '/3'
        )
        if (response3) {
          this.dadosDoResultadoOdontologia = response3.data
          const dadosDoMunicipioOdontologia =
            this.dadosDoResultadoOdontologia.find((item) => {
              return item.ibge_ine === 'MUN'
            })
          this.por_municipio_odontologia = dadosDoMunicipioOdontologia.numerador
          this.por_municipio_odontologia_resultado =
            dadosDoMunicipioOdontologia.resultado
        }

        // busca os dados do municipio hiv e sifilis
        let response4 = await this.$api.get(
          '/app/indicadores-aps/resultado/' + this.cod_ibge + '/2'
        )
        if (response4) {
          this.dadosDoResultadoHivSifilis = response4.data
          const dadosDoMunicipioHivSifilis =
            this.dadosDoResultadoHivSifilis.find((item) => {
              return item.ibge_ine === 'MUN'
            })
          this.por_municipio_hiv_sifilis = dadosDoMunicipioHivSifilis.numerador
          this.por_municipio_hiv_sifilis_resultado =
            dadosDoMunicipioHivSifilis.resultado
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    printColorColumn(resultado) {
      if (parseInt(resultado) >= 60) {
        return 'blue'
      } else {
        return 'red'
      }
    },

    printColorColumnPreNatal(resultado) {
      if (parseInt(resultado) >= 45) {
        return 'blue'
      } else {
        return 'red'
      }
    },

    retornaPorcentagemMunicipio(valor) {
      let denominador = 0
      if (
        parseInt(this.por_municipio_gestantes_informadas) >=
        parseInt(this.por_municipio_gestantes_estimadas)
      ) {
        denominador = parseInt(this.por_municipio_gestantes_informadas)
      } else {
        denominador = parseInt(this.por_municipio_gestantes_estimadas)
      }
      let resultado = (valor / denominador) * 100
      if (Number.isNaN(resultado)) {
        return ''
      }
      return ' (' + resultado.toFixed(0) + '%)'
    },

    retornaPorcentagemEquipe(valor) {
      let denominador = 0
      if (
        parseInt(this.por_equipe_gestantes_informadas) >=
        parseInt(this.por_equipe_gestantes_estimadas)
      ) {
        denominador = parseInt(this.por_equipe_gestantes_informadas)
      } else {
        denominador = parseInt(this.por_equipe_gestantes_estimadas)
      }
      let resultado = (valor / denominador) * 100
      if (Number.isNaN(resultado)) {
        return ''
      }
      return ' (' + resultado.toFixed(0) + '%)'
    },

    calculaPorcentagemSerieHistoricaMunicipio(valor) {
      let denominador = 0
      if (
        parseInt(this.por_municipio_gestantes_informadas) >=
        parseInt(this.por_municipio_gestantes_estimadas)
      ) {
        denominador = parseInt(this.por_municipio_gestantes_informadas)
      } else {
        denominador = parseInt(this.por_municipio_gestantes_estimadas)
      }
      let resultado = (valor / denominador) * 100
      if (Number.isNaN(resultado)) {
        return ''
      }
      return parseInt(resultado.toFixed(0))
    },

    calculaPorcentagemSerieHistoricaEquipe(valor) {
      let denominador = 0
      if (
        parseInt(this.por_equipe_gestantes_informadas) >=
        parseInt(this.por_equipe_gestantes_estimadas)
      ) {
        denominador = parseInt(this.por_equipe_gestantes_informadas)
      } else {
        denominador = parseInt(this.por_equipe_gestantes_estimadas)
      }
      let resultado = (valor / denominador) * 100
      if (Number.isNaN(resultado)) {
        return ''
      }
      return parseInt(resultado.toFixed(0))
    },

    async carregarSerieHistorica() {
      try {
        let array_chart_municipio_pre_natal = []
        let array_chart_municipio_odontologia = []
        let array_chart_municipio_hiv_sifilis = []

        let response_pre_natal = await this.$api.get(
          '/app/serie-historica/municipio/' + this.cod_ibge + '/11'
        )
        let response_odontologia = await this.$api.get(
          '/app/serie-historica/municipio/' + this.cod_ibge + '/33'
        )
        let response_hiv_sifilis = await this.$api.get(
          '/app/serie-historica/municipio/' + this.cod_ibge + '/22'
        )

        //carregar eixo x
        let array_xaxis = []
        for (let i = 0; i < response_pre_natal.data.length; i++) {
          array_xaxis.push(response_pre_natal.data[i].mes_ano)
          this.xaxis.push(response_pre_natal.data[i].mes_ano)
        }
        this.$refs.chartData.updateOptions({
          xaxis: {
            categories: array_xaxis,
          },
        })

        // carregar dados do município pré-natal
        for (let i = 0; i < response_pre_natal.data.length; i++) {
          array_chart_municipio_pre_natal.push(
            response_pre_natal.data[i].resultado
          )
        }
        // carregar dados do município odontologia
        for (let i = 0; i < response_odontologia.data.length; i++) {
          array_chart_municipio_odontologia.push(
            response_odontologia.data[i].resultado
          )
        }
        // carregar dados do município hiv e sifilis
        for (let i = 0; i < response_hiv_sifilis.data.length; i++) {
          array_chart_municipio_hiv_sifilis.push(
            response_hiv_sifilis.data[i].resultado
          )
        }

        this.$refs.chartData.updateSeries([
          {
            name: 'Município: Pré-natal',
            data: array_chart_municipio_pre_natal,
          },
          {
            name: 'Município: Odontologia',
            data: array_chart_municipio_odontologia,
          },
          {
            name: 'Município: HIV e Sífilis',
            data: array_chart_municipio_hiv_sifilis,
          },
        ])

        this.arrayChartMunicipioPreNatal = array_chart_municipio_pre_natal
        this.arrayChartMunicipioOdontologia = array_chart_municipio_odontologia
        this.arrayChartMunicipioHivSifilis = array_chart_municipio_hiv_sifilis
        // this.data_dados_chart = this.formatDate(response_pre_natal.data[response_pre_natal.data.length - 1].data_dados);
      } catch (err) {
        console.log(err)
      }
    },

    async carregarSerieHistoricaPorEquipe(nu_ine) {
      try {
        let array_chart_equipe_pre_natal = []
        let array_chart_equipe_odontologia = []
        let array_chart_equipe_hiv_sifilis = []

        let response_pre_natal = await this.$api.get(
          '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/11'
        )
        let response_odontologia = await this.$api.get(
          '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/33'
        )
        let response_hiv_sifilis = await this.$api.get(
          '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/22'
        )

        this.$refs.chartData.updateOptions({
          xaxis: {
            categories: this.xaxis,
          },
        })

        // carregar dados da equipe no pré-natal
        for (let i = 0; i < this.xaxis.length; i++) {
          var eixo_x_atual = this.xaxis[i]
          for (const item of response_pre_natal.data) {
            var resultado = 0
            if (item.mes_ano == eixo_x_atual) {
              resultado = item.resultado
              break
            } else {
              resultado = null
            }
          }
          array_chart_equipe_pre_natal.push(resultado)
        }

        // carregar dados da equipe no odontologia
        for (let i = 0; i < this.xaxis.length; i++) {
          var eixo_x_atual = this.xaxis[i]
          for (const item of response_odontologia.data) {
            var resultado = 0
            if (item.mes_ano == eixo_x_atual) {
              resultado = item.resultado
              break
            } else {
              resultado = null
            }
          }
          array_chart_equipe_odontologia.push(resultado)
        }

        // carregar dados da equipe no hiv e sifilis
        for (let i = 0; i < this.xaxis.length; i++) {
          var eixo_x_atual = this.xaxis[i]
          for (const item of response_hiv_sifilis.data) {
            var resultado = 0
            if (item.mes_ano == eixo_x_atual) {
              resultado = item.resultado
              break
            } else {
              resultado = null
            }
          }
          array_chart_equipe_hiv_sifilis.push(resultado)
        }

        this.$refs.chartData.updateSeries([
          {
            name: 'Município: Pré-natal',
            data: this.arrayChartMunicipioPreNatal,
          },
          {
            name: 'Município: Odontologia',
            data: this.arrayChartMunicipioOdontologia,
          },
          {
            name: 'Município: HIV e Sífilis',
            data: this.arrayChartMunicipioHivSifilis,
          },
          {
            name: 'Equipe: Pré-natal',
            data: array_chart_equipe_pre_natal,
          },
          {
            name: 'Equipe: Odontologia',
            data: array_chart_equipe_odontologia,
          },
          {
            name: 'Equipe: HIV e Sífilis',
            data: array_chart_equipe_hiv_sifilis,
          },
        ])
        // this.arrayChartMunicipio = array_chart_municipio_pre_natal;
        // this.data_dados_chart = this.formatDate(response_pre_natal.data[response_pre_natal.data.length - 1].data_dados);
      } catch (err) {
        console.log(err)
      }
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.equipe)
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.green {
  color: green;
}
.red {
  color: red;
}

@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
#tres-indicadores-pre-natal .info-table {
  justify-content: flex-end;
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
  #tres-indicadores-pre-natal .info-table {
    gap: 10px;
  }
}
</style>
